import { h } from 'preact'
import Pagination from '../../preact-components/pagination/Pagination'

export interface PaginationProps {
  page?: number
  pageSize?: number
  total?: number
  pageSizes?: number[]
}

interface PaginationComponentProps {
  pagination?: PaginationProps
  onPageChange?: (page: number) => void
  onPageSizeChange?: (pageSize: number) => void
  displayListUpwards?: boolean
}

const PaginationComponent = ({ pagination, onPageChange, onPageSizeChange, displayListUpwards }: PaginationComponentProps) => (
  <Pagination
    displayListUpwards={displayListUpwards}
    currentPage={pagination?.page || 0}
    total={pagination?.total || 0}
    pageSize={pagination?.pageSize || 0}
    pageSizes={pagination?.pageSizes || [10, 25, 50]}
    onPageChange={(page: number) => onPageChange?.(page)}
    onPageSizeChange={(pageSize: number) => onPageSizeChange?.(pageSize)}
  />
)

export default PaginationComponent
